// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_UpdateRelacaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /localidades/updateRelacao
 *
 * Updates a location-franchise relationship.
 */
import { registerContract } from './validate'

export interface Localidades_UpdateRelacaoInput {
localidade_id: number
franquia_id: number
data_inicio?: string
data_fim?: string
}

registerContract('Localidades_UpdateRelacaoInput', {
  localidade_id: { type: 'number',  required: true },
  franquia_id:   { type: 'number',  required: true },
  data_inicio:   { type: 'string',  required: false },
  data_fim:      { type: 'string',  required: false },
})
